<template>
  <v-container fluid fill-height class="background">
    <v-layout align-center justify-center>
      <v-flex xs12 sm8 md4>
        <v-card class="elevation-12">
          <v-toolbar dark color="blue">
            <v-toolbar-title>Login</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-form @submit.prevent="login">
              <v-text-field
                v-model="email"
                prepend-icon="person"
                name="email"
                label="Email"
                type="email"
                browser-autocomplete="email"
                :error-messages="emailError"
              />
              <v-text-field
                id="password"
                v-model="password"
                prepend-icon="lock"
                name="password"
                label="Password"
                type="password"
                browser-autocomplete="current-password"
                :error-messages="passwordError"
              />
              <v-spacer />
              <v-btn type="submit" color="primary">
                Login
              </v-btn>
              <v-btn type="button" color="primary" to="/new-account">
                Create Admin Account
              </v-btn>
            </v-form>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { auth } from '@/plugins/firebase';

export default {
  data: () => ({
    email: '',
    password: '',
    emailError: null,
    passwordError: null,
  }),
  methods: {
    async login() {
      this.emailError = null;
      this.passwordError = null;
      try {
        await auth.signInWithEmailAndPassword(this.email, this.password);
        this.$router.push({ name: 'redirect' });
      } catch (e) {
        switch (e.code) {
          case 'auth/invalid-email':
            this.emailError = 'Email is not valid';
            break;
          case 'auth/user-disabled':
            this.emailError = 'This account is disabled';
            break;
          case 'auth/user-not-found':
            this.emailError = 'This email has no associated account';
            break;
          case 'auth/wrong-password':
            this.passwordError = 'The password is incorrect';
            break;
          default:
            throw e;
        }
      }
    },
  },
};
</script>

<style scoped>
.background {
  background-image: linear-gradient(0deg, rgba(0, 0, 0, 0.5)),
    url('../assets/login_bg_smaller.jpeg');
  background-repeat: no-repeat;
  background-size: cover;
}
</style>
